module.exports = __webpack_public_path__ + "static/media/20ECE14.bf1bcff4.jpg";